/**
 * @file   src\utils\enums.ts
 * @brief  This file is responsible define enums.
 * @date   June, 2024
 * @author ZCO Engineer
 * @copyright (c) 2024, ZCO
 */


// Sort order type enum.
export enum SortOrderType {
  'ASC' = 1,
  'DESC' = 2,
}

export enum userType {
  'SUPER-ADMIN' = 'SUPERADMIN',
  'CARWASH-OWNER' = 'CARWASHOWNER'
}

export enum SubscriptionType {
  "day" = 1,
  "month" = 2,
  // "year" = 3,
}

export enum DiscountType {
  "AMOUNT" = 1,
  "PERCENTAGE" = 2
}

// Payment Type enum
export enum PaymentType {
  Stripe = 1,
  // Worldpay = 2,
}

/** Location-level tender for fleet washes. */
export enum FleetPaymentMode {
  CreditCard = 1,
  ByCheck = 2,
}

// Solution Type enum
export enum SolutionType {
  "Sales Message" = 1,
  // "Test" = 2,
}

// Account Holder Type enum
export enum AccountHolderType {
  Individual = 1,
  Company = 2,
}

// Equipment Type enum
export enum EquipmentType {
  "Tunnel" = 1,
  "In Bay" = 2,
  "Self Serve" = 3,
  "Dog Wash" = 4,
  "Vacuum" = 5
  
}

/** LPR switch + usage are shown for these bay types only. */
export const equipmentTypeSupportsLpr = (type: number): boolean =>
  type === EquipmentType['Tunnel'] || type === EquipmentType['In Bay'];

/** Pulse UI is hidden and pulse fields are cleared when switching to this type. */
export const equipmentTypeHidesPulse = (type: number): boolean =>
  type === EquipmentType['In Bay'] || type === EquipmentType['Tunnel'] ;

export enum EquipmentTypeLabel {
  Tunnel = "Tunnel",
  Bay = "In Bay",
  SelfServe = "Self Serve",
  DogWash = "Dog Wash",
  Vacuum = "Vacuum",
}

// Wash type enum
export enum WashType {
  "Single Wash" = 1,
  "Subscription" = 2,
}

export enum RevenueReportsWashType {
  "Single Wash" = 1,
  "Subscription" = 2,
  "Prepaid Discount Packages" = 3,
  "Up sell" = 4,
  "Gift Card" = 5,
}
// Connectivity Type enum
export enum ConnectivityType {
  Wifi = 1,
  Ethernet = 2,
  Cellular = 3,
  Satellite = 4,
  FiberOptic = 5,
  Dsl = 6,
}

// Device type enum
export enum DeviceType {
  WASH_DEVICE = 1,
  PAX = 2,
  LPR = 3,
}

const DEVICE_TYPE_LABELS: Record<DeviceType, string> = {
  [DeviceType.WASH_DEVICE]: 'Arduino Device',
  [DeviceType.PAX]: 'PAX',
  [DeviceType.LPR]: 'LPR',
};

export function getDeviceTypeLabel(deviceType: number | string | null | undefined): string {
  const n = Number(deviceType);
  if (!Number.isNaN(n) && DEVICE_TYPE_LABELS[n as DeviceType] !== undefined) {
    return DEVICE_TYPE_LABELS[n as DeviceType];
  }
  if (deviceType === null || deviceType === undefined || deviceType === '') {
    return '—';
  }
  return String(deviceType);
}

// RevenueReports filter Option Type enum
export enum RevenueReportsOption {
  "Current Month" = 1,
  "Current Year" = 2,
  "Custom" = 3,
}


export enum SubscriptionStatus {
  Inactive = 0,
  Active = 1,
  Cancelled = 2,
}

export enum serviceType {
  Inbay = 0,
  SelfServe = 1,
  DogWash = 2,
  Vacuum = 3
}

export const ItemTypeEnum = {
  0: 'Hardware',
  1: 'Marketing Package',
  2: 'Initial Fee',
  null: 'Subscription',
} as const;

// Advertisement type enum
export enum AdvertisementType {
  "Text Advertisement" = 1,
  "Image Advertisement" = 2,
  "Video Advertisement" = 3,
}

export enum FontSizeType {
  "24px" = "24px",
  "25px" = "25px",
  "26px" = "26px",
  "27px" = "27px",
  "28px" = "28px",
  "29px" = "29px",
  "30px" = "30px",
  "31px" = "31px",
  "32px" = "32px",
  "33px" = "33px",
  "34px" = "34px",
  "35px" = "35px",
  "36px" = "36px",
  "37px" = "37px",
  "38px" = "38px",
  "39px" = "39px",
  "40px" = "40px",
}

export enum BoxFontSizeType {
  "14px" = "14px",
  "15px" = "15px",
  "16px" = "16px",
  "17px" = "17px",
  "18px" = "18px",
  "19px" = "19px",
  "20px" = "20px",
  "21px" = "21px",
  "22px" = "22px",
  "23px" = "23px",
  "24px" = "24px"
}

export enum daysOfweekType {
  "Sunday" = 1,
  "Monday" = 2,
  "Tuesday" = 3,
  "Wednesday" = 4,
  "Thursday" = 5,
  "Friday" = 6,
  "Saturday" = 7
}

// recordCounts Type
export const recordCounts = {
  20: 20,
  40: 40,
  60: 60,
  80: 80,
  100: 100,
} as const;